import 'babel-polyfill';
import Swiper from 'swiper';
import svg4everybody from 'svg4everybody';
import ScrollMagic from 'scrollmagic';
import 'gsap/ScrollToPlugin';
import $ from 'jquery';
import 'tooltipster/dist/js/tooltipster.main.min';
import 'tooltipster/dist/js/tooltipster.bundle.min';

svg4everybody();

window.$ = $;
window.jQuery = $;
window.Swiper = Swiper;
window.ScrollMagic = ScrollMagic;
